import React from 'react';
import Modal from '../common/Modal';

export default function NFTDetailModal({ nft, onClose }) {
  if (!nft) return null;
  return (
    <Modal open={!!nft} onClose={onClose} title={nft.name} subtitle={`#${nft.id}`}>
      <div className="nft-detail">
        <div className="hero-img"><img src={nft.gif} alt={nft.name} /></div>
        <div>
          <div className="info-row"><span className="k">Rarity</span><span className="v"><span className={`nft-rarity rarity-${nft.rarity}`} style={{ position: 'static' }}>{nft.rarity}</span></span></div>
          <div className="info-row"><span className="k">Value</span><span className="v">${nft.value}</span></div>
          <div className="info-row"><span className="k">Collection</span><span className="v">Adrenaline Genesis</span></div>
          <div className="info-row"><span className="k">Token ID</span><span className="v" style={{ fontFamily: 'monospace' }}>{nft.id}</span></div>
        </div>
      </div>
    </Modal>
  );
}
